import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Container } from 'react-bootstrap';

const translations = {
    en: require('../../Translate/en.json'),
    ar: require('../../Translate/ar.json'),
};

const ServicesSlider = ({ data }) => {
    const { i18n } = useTranslation();
    const isLang = i18n.language;
    const t = translations[isLang || 'en'];
    const isEnglish = isLang === 'en';

    // Animation variants
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                delayChildren: 0.1
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut"
            }
        }
    };

    const imageVariants = {
        hidden: { opacity: 0, scale: 0.9, x: isEnglish ? 50 : -50 },
        visible: {
            opacity: 1,
            scale: 1,
            x: 0,
            transition: {
                duration: 0.8,
                ease: "easeOut"
            }
        }
    };

    return (
        <div className="website-development-modern">
            {/* Section 1 - Enhanced Hero Section */}
            <div className={`hero-section-modern ${isLang === "en" ? "ltr" : "rtl"}`} dir={isLang === "en" ? "ltr" : "rtl"}>
                <Container fluid className="hero-container-wrapper">
                    <motion.div
                        className="hero-content-wrapper"
                        variants={containerVariants}
                        initial="hidden"
                        animate="visible"
                    >
                        {/* Content Section */}
                        <motion.div
                            className="content-modern"
                            variants={itemVariants}
                        >
                            <motion.h1
                                className="title-modern"
                                variants={itemVariants}
                            >
                                {data.title}
                            </motion.h1>
                            <motion.p
                                className={`description-modern ${isLang === "ar" ? 'text-end' : 'text-start'}`}
                                variants={itemVariants}
                            >
                                {data.dec}
                            </motion.p>
                            <motion.div
                                className={`button-container-modern ${isLang === "en" ? 'text-start' : 'text-end'}`}
                                variants={itemVariants}
                            >
                                <motion.button
                                    className="request-button-modern"
                                    whileHover={{ scale: 1.05, y: -2 }}
                                    whileTap={{ scale: 0.95 }}
                                    transition={{ type: "spring", stiffness: 400, damping: 17 }}
                                >
                                    <span className="button-text">{t.GetStarted}</span>
                                    <span className="button-arrow">{isEnglish ? '→' : '←'}</span>
                                </motion.button>
                            </motion.div>
                        </motion.div>

                        {/* Image Section */}
                        <motion.div
                            className="image-container-modern"
                            variants={imageVariants}
                        >
                            <img
                                src={data.img}
                                alt={data.title || "Service Image"}
                                className="hero-image-modern"
                                loading="lazy"
                            />
                        </motion.div>
                    </motion.div>
                </Container>
            </div>

            {/* Section 2 */}
            <div className="dark-section-modern_container">
                <div className="dark-section-modern">
                    <h2 className={`dark-title-modern ${isLang == "ar" ? 'text-end' : 'text-start'} `}>{data.title2}</h2>
                    <p className={`dark-description-modern ${isLang == "ar" ? 'text-end' : 'text-start'} `}>{data.dec2}</p>
                </div>
            </div>
        </div>
    );
};

export default ServicesSlider;
